<template>
    <div class="container">
        <h1>Users</h1>
        <div class="row justify-content-center">
            <div class="col">
                <UsersTable admin />
            </div>
        </div>
    </div>
</template>

<script>
import UsersTable from '@/components/user/UsersTable.vue'
export default {
    name: 'EditUsers',
    components: {
        UsersTable
    },
    data: () => {
        return {
        }
    },
    head: {
        title: 'Users'
    },
    methods: {
    },
    async mounted() {
    }
}
</script>